import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class UnitEditRequest_se {
    constructor() {
        this.entity = 'unitEditRequest';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }

    save(model) {
        return Api.save(this.entity,model)
    }

    getUnits(buildingId){
        let formData=new FormData();
        formData.set("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/units/',
            headers: {'Content-Type': 'application/json'},
        })
    }


    page() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }
  edit(id,type) {
      let formData=new FormData()
      formData.set("id",id)
      formData.set("type",type)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/edit/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    new(id) {
      let formData=new FormData()
      formData.set("id",id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/new/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    search(buildingId, unitId) {
        let formData=new FormData()
        formData.set("buildingId",buildingId)
        formData.set("unitId",unitId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    remove(buildingId, unitId) {
        let formData=new FormData()
        formData.set("buildingId",buildingId)
        formData.set("unitId",unitId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/remove/',
            headers: {'Content-Type': 'application/json'},
        })
    }




}
export default new UnitEditRequest_se();
